// src/api/regattajudge/index.js
import { authClient, API } from '../../utils/index';

// Listar
export function getRegattaJudgesByRegatta(id) {
  return authClient().get(`${API}/regattaJudge/by-regatta/${id}`);
}

// Crear
export const postRegattaJudge = (payload) => {
  return authClient().post(`${API}/regattaJudge`, payload);
};

// Actualizar
export const putRegattaJudge = (id, payload) => {
  return authClient().put(`${API}/regattaJudge/${id}`, payload);
};

// Borrar
export const deleteRegattaJudge = (id) => {
  return authClient().delete(`${API}/regattaJudge/${id}`);
};
